settings_module = settings_module or {}
settings_module.sensor_detail = ()->

    variant_choices = _.map($('#id_variant option'), (el)-> [$(el).attr('value'), $(el).text()] )
    $variant = $('#id_variant')
    $medium = $('#id_medium')

    # --------------------------------
    show_extras = (prefix)->
        $('.row.formextras:not(.hide)').addClass('hide')
        $('#' + prefix + '_container').removeClass('hide')

    # --------------------------------
    handle_medium = ()->
        medium = $medium.val()
        variants = _.filter(variant_choices, (i)-> i[0].indexOf(medium) == 0 )
        act_variant = $variant.val()

        # roznuti/zhasnuti policka s variantou
        if variants.length <= 1
            # skryti varint selektitka, pokud tam je jedina hodnota
            $variant.closest('.form-group').addClass('hide')
        else
            $variant.closest('.form-group').removeClass('hide')
        # aktualizace obsahu selektitka s variantama
        $variant.empty()
        for i in [0..variants.length - 1]
            if variants[i][0] == act_variant
                selected = 'selected="selected" '
            else
                selected = ''
            $variant.append('<option ' + selected + 'value="' + variants[i][0] + '">' + variants[i][1] + '</option>')

        # aktualizace extras formiku
        $variant.change()

    # --------------------------------
    handle_variant = ()->
        val = $variant.val()
        show_extras(val)

    # --------------------------------
    handle_advanced = ()->
        $check = $(this)
        $container = $check.closest('.formextras')

        if $check.is(':checked')
            $container.find('table .advanced').show()
        else
            $container.find('table .advanced').hide()

    $('input.advanced').change(handle_advanced)

    # --------------------------------
    handle_enabled = ()->
        $check = $(this)
        $container = $check.closest('tr')

        if $check.is(':checked')
            $container.removeClass('disabled')
            $container.find('input:not(:first),button,select').removeAttr('disabled', 'disabled')
            title = $container.find('input[name^="power_3ph-title_"]')
            if $.trim(title.val()).length == 0
                title.val($container.find('td:first p').text())
        else
            $container.addClass('disabled')
            $container.find('input:not(:first),button,select').attr('disabled', 'disabled')
    $('input[name^="power_3ph-enable_"]').change(handle_enabled)
    $('input[name^="power_3ph-enable_"]').change()

    handle_total_consumption = ()->
        $check = $(this)
        $container = $check.closest('table')
        $import_container = $container.find('input[name$="_import"]').closest('tr')
        $export_container = $container.find('input[name$="_export"]').closest('tr')

        if not($check.val() == "")
            $import_container.removeClass('disabled').find('input,button').removeAttr('disabled', 'disabled')
            $export_container.removeClass('disabled').find('input,button').removeAttr('disabled', 'disabled')
        else
            $import_container.addClass('disabled').find('input,button').attr('disabled', 'disabled')
            $export_container.addClass('disabled').find('input,button').attr('disabled', 'disabled')

    $('select[name$="consumption_stream"]').change(handle_total_consumption)
    $('select[name$="consumption_stream"]').change()

    # inicializace advanced checkboxu
    # - to jestli ma byt zaskrtnuty nebo ne je dano obsahem formulare
    # - pokud v kteremkoliv z poslednich advanced policek v radku tabulky
    #   je nejaka hodnota (value pro operaci), pak checkbox zaskrtavame
    # - v opacnem pripade zustane nezsaktnuty, ale musime advanced sloupecky
    #   z tabulky smazat
    $('input.advanced').each ()->
        $check = $(this)
        $container = $check.closest('.formextras')
        check_adv_input = false

        $container.find('tr').each ()->
            $tr = $(this)
            $last_td = $tr.find('td:last')
            if $last_td.hasClass('advanced')
                $input = $last_td.find('input')
                if $input.length && $input.val().length
                    check_adv_input = true

        force_handler = $check.prop('checked') == check_adv_input
        $check.prop('checked', check_adv_input)
        if force_handler
            $check.change()


    $variant.change(handle_variant)
    $medium.change(handle_medium)
    $medium.change()



    # ============================================


    selected_color = null
    selected_label = null
    selected_id = null
    $modal = $('#colorselector')

    _get_color = (classnames)->
        res = _.filter(classnames.split(' '),(d)-> d.match(/^color.*/i))
        if res.length > 0
            return res[0]
        else
            return false


    color_table_button_handler = ()->
        new_color = _get_color($(this).attr('class'))
        $btn = $('#'+selected_id).prev()
        if selected_color.length
            old_idx = colors[selected_color].indexOf(selected_label)
            colors[selected_color].splice(old_idx, 1)
        colors[new_color].push(selected_label)

        $btn.attr('class', "btn #{new_color}")
        $btn.next('input').val(new_color)

        $modal.modal('hide')

        $("#colorselector .color-settings").empty()

        false


    $('.color-settings button').on 'click', (event)->
        selected_color = _get_color($(this).attr('class'))
        selected_label = $(this).closest('tr').find('input[name*="title"]').val()
        selected_id = $(this).parent().find('input').attr('id')

        $table = $("#colorselector .color-settings")
        keys = _.keys(colors)

        keys.sort()
        tds = _.map keys, (value, key, list)->
            '<div class="col-xs-12 col-sm-3"><button id="button-index-' + key + '" class="btn ' + value + '" title="' + colors[value].join('\n') + '">' + colors[value].join('<br>') + '</button></div>'

        $table.append('<div class="row">' + tds.slice(0, 4).join('') + '</div>')
        $table.append('<div class="row">' + tds.slice(4, 8).join('') + '</div>')
        $table.append('<div class="row">' + tds.slice(8, 12).join('') + '</div>')
        $table.append('<div class="row">' + tds.slice(12, 16).join('') + '</div>')
        $table.append('<div class="row">' + tds.slice(16, 20).join('') + '</div>')

        $('#colorselector .color-settings button').on('click', color_table_button_handler)

        $modal.modal('show')

        false

    $modal.on 'hidden.bs.modal', (e)->
        $("#colorselector .color-settings").empty()
